import {
  GridComparatorFn,
  gridStringOrNumberComparator,
} from "@mui/x-data-grid-premium";

export const nullHandlingSortComparator: GridComparatorFn = (
  v1,
  v2,
  cellParams1,
  cellParams2
): number => {
  const sortModel = cellParams1.api.getSortModel();
  const sortColumn = sortModel.find((sm) => sm.field == cellParams1.field);
  if (sortColumn && sortColumn.sort == "desc") {
    if ((v1 == null && v2 == null) || (v1 == "" && v2 == "")) {
      return -1;
    }
    if (v1 == null || v1 == "") {
      return -1;
    }
    if (v2 == null || v2 == "") {
      return 1;
    }
  } else {
    if ((v1 == null && v2 == null) || (v1 == "" && v2 == "")) {
      return 0;
    }
    if (v1 == null || v1 == "") {
      return 1;
    }
    if (v2 == null || v2 == "") {
      return -1;
    }
  }
  return gridStringOrNumberComparator(v1, v2, cellParams1, cellParams2);
};
